// styles/AgentOnboardingPage.styles.js
const AgentOnboardingStyles = {
  rootBox: {
    padding: '40px',
    maxWidth: '600px',
    margin: 'auto',
  },
  paper: {
    padding: '30px',
  },
  header: {
    marginBottom: '16px',
  },
  textField: {
    marginBottom: '24px',
  },
  gridContainer: {
    marginBottom: '16px',
  },
  disclosureText: {
    marginBottom: '16px',
    marginTop: '32px',
  },
  disclosurePaper: {
    padding: '20px',
    marginBottom: '24px',
    backgroundColor: '#f4f4f9',
  },
  fileUploadButton: {
    marginTop: '24px',
    marginBottom: '24px',
  },
  errorText: {
    marginBottom: '16px',
  },
  submitButton: {
    marginTop: '24px',
  },
};

export default AgentOnboardingStyles;
